var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.changes)?_c('VueMarkdown',{staticClass:"md"},[_vm._v("\n    "+_vm._s(_vm.changes)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }